<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="title" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    <tidy-row [align]="'center'">
      @if (type === 'support.other') {
        <tidy-text
          [body]="otherText" />
      }
      <tidy-text
        [body]="'Open a dispute directly with'" /><span>&nbsp;</span>
        <tidy-text
          [body]="job?.homekeepers[0].first_name" /><span>&nbsp;</span>
          <tidy-text
            [body]="'for the job on'" /><span>&nbsp;</span>
            <tidy-text
              [body]="job?.job?.date | parseDateTime:'MMM d'" /><span>&nbsp;</span>
              <tidy-text
                [body]="'at'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="(job?.job?.start_time | parseDateTime:'h:mma') + '. ' + job?.homekeepers[0].first_name" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'will have 3 days to accept your dispute or propose another resolution.'" />
                </tidy-row>

                <tidy-card>
                  <form [formGroup]="form">
                    <tidy-row class="field-top-padding field-bottom-padding">
                      <tidy-textarea
                        [label]="'What Happened?'"
                        formControlName="message"
                        [form]="form.controls.message"
                        [submitted]="submitted"
                        [icon]="'assets/svg/information-circle.svg'"
                        [errorMessage]="'Please enter a message'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-input
                        [label]="'What % of the job cost do you want back?'"
                        [icon]="'assets/svg/cash.svg'"
                        formControlName="percentage"
                        [form]="form.controls.percentage"
                        [submitted]="submitted"
                        [customMask]="percentageMask"
                        [inputMode]="'numeric'"
                        [errorMessage]="'Please enter how much you are seeking.'" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-radio-button
                        [label]="'How do you want the money back?'"
                        formControlName="cashback"
                        [form]="form.controls.cashback"
                        [items]="[{viewValue: 'Credit', value: 'credit'},{viewValue: 'Refund', value: 'refund'}]" />
                    </tidy-row>
                  </form>
                </tidy-card>

                @if (errorMessage) {
                  <tidy-error-message
                    [text]="errorMessage" />
                }

                <tidy-button
                  [text]="'Open Job Dispute'"
                  [action]="boundSend"
                  class="primary" />

                <tidy-row [align]="'center'">
                  <tidy-text
                    [header]="'Dispute Tips:'" />
                </tidy-row>

                <tidy-alert class="vertical-align-center" style="padding: 15px 15px 15px 15px">
                  <tidy-row>
                    <ion-row>
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="'assets/svg/split-money.svg'"
                          style="width:40px;height:50px" />
                      </tidy-row>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="'Try a partial resolution'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            body='Seeking "all" or "nothing" is often is rejected by the other party.' />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-alert>

                <tidy-alert class="vertical-align-center" style="padding: 15px 15px 15px 15px">
                  <tidy-row>
                    <ion-row>
                      <tidy-row class="vertical-align-center">
                        <tidy-image
                          [src]="'assets/svg/shake-hands.svg'"
                          style="width:40px;height:50px" />
                      </tidy-row>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="'Be polite'" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="'Parties will be more likely to accept your resolution.'" />
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-alert>

              </tidy-wrapper>
            </ng-template>

            @if (!isRightSideContent) {
              <app-scroll-wrapper [templateContent]="content" />
            }

            @if (isRightSideContent) {
              <ion-content class="ion-content-right-column">
                <ng-container *ngTemplateOutlet="content" />
              </ion-content>
            }
